import React from "react";
import { COLORS } from "shared/consts";
import {IconProps} from './index.tsx';

export const Scheme: React.FC<IconProps> = ({
                                                  fill = COLORS.FG.SOFT,
                                                  width = 24,
                                                  height = 24,
                                                  className,
                                              }) => {
    return (
        <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
             width={width} height={height} fill="none">
            <rect id="24 / Business / Union" width={width} height={height} x="0.000000" y="0.000000"/>
            <path id="Union"
                  d="M10.5 7.46061L10.5 4.5L13.5 4.5L13.5 7.46061L10.5 7.46061ZM9 4C9 3.44772 9.44772 3 10 3L14 3C14.5523 3 15 3.44772 15 4L15 7.9606C15 8.4991 14.5744 8.93819 14.0412 8.95977L18.1241 14L20 14C20.5523 14 21 14.4477 21 15L21 19C21 19.5523 20.5523 20 20 20L16 20C15.4477 20 15 19.5523 15 19L15 18.0652L9 18.0652L9 19C9 19.5523 8.55228 20 8 20L4 20C3.44772 20 3 19.5523 3 19L3 15C3 14.4477 3.44772 14 4 14L5.86373 14L9.99437 8.96059C9.44468 8.95756 9 8.51101 9 7.96061L9 4ZM9 16.5652L15 16.5652L15 15C15 14.4477 15.4477 14 16 14L16.1937 14L12.1114 8.96061L11.9339 8.96061L7.80323 14L8 14C8.55228 14 9 14.4477 9 15L9 16.5652ZM4.5 18.5L4.5 15.5L7.5 15.5L7.5 18.5L4.5 18.5ZM16.5 15.5L16.5 18.5L19.5 18.5L19.5 15.5L16.5 15.5Z"
                  fill={fill} fillRule="evenodd"/>
        </svg>
    );
};
